import { useState } from "react";

function SolarCalculator() {
  const [bill, setBill] = useState("");
  const [data, setData] = useState(null);

  // 🔥 Form fields
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");

  const calculate = () => {
    const monthlyBill = Number(bill);

    if (!monthlyBill || monthlyBill <= 0) {
      alert("Enter valid bill");
      return;
    }

    const systemSize = (monthlyBill / 1000).toFixed(1);
    const cost = systemSize * 60000;
    const yearlySavings = monthlyBill * 12 * 0.8;
    const payback = (cost / yearlySavings).toFixed(1);

    setData({ systemSize, cost, yearlySavings, payback });
  };

  // 🔥 Submit form to backend
  const handleSubmit = async () => {
  if (!name || !phone) {
    alert("Fill all details");
    return;
  }

  const response = await fetch("https://api.web3forms.com/submit", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      access_key: "cdfd2023-f3db-46b4-b9a7-a1410c603cf8",
      subject: "New Solar Calculator Lead",
      from_name: "Solar Calculator",
      name,
      phone,
      monthly_bill: bill,
      system_size: data?.systemSize,
      estimated_cost: data?.cost,
      yearly_savings: data?.yearlySavings,
      payback_years: data?.payback,
    }),
  });

  const result = await response.json();

  if (result.success) {
    alert("Lead Saved Successfully ✅");
    setName("");
    setPhone("");
  } else {
    alert("Something went wrong. Please try again.");
  }
};
  return (
    <div className="calculator-section">
      <h1>💰 Solar Savings Calculator</h1>

      <input
        type="number"
        placeholder="Monthly bill (₹)"
        value={bill}
        onChange={(e) => setBill(e.target.value)}
      />

      <button onClick={calculate}>Calculate</button>

      {data && (
        <div className="result-box">
          <h3>⚡ {data.systemSize} kW</h3>
          <h3>💰 ₹{data.cost}</h3>
          <h3>📊 ₹{data.yearlySavings}</h3>
          <h3>⏳ {data.payback} Years</h3>

          {/* 🔥 LEAD FORM */}
          <div className="lead-form">
            <h2>Get Free Consultation</h2>

            <input
              type="text"
              placeholder="Your Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />

            <input
              type="text"
              placeholder="Phone Number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />

            <button onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default SolarCalculator;